import PropTypes from 'prop-types'

import Head from '../../common/head'
import ProfileCheck from '../layout/profile-check'
import SurveyPopup from '../footer/survey-popup'
import { SURVEY_POPUP_URL } from '../constants'

const View = ({ head, navbar, footer, children }) => {
  return <>
    <Head {...head} />
    <ProfileCheck>
      <main className={'z-0 min-h-screen'}>
        {children}
      </main>
      <SurveyPopup surveyUrl={SURVEY_POPUP_URL} />
    </ProfileCheck>
  </>
}

View.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  children: PropTypes.any,
  footer: PropTypes.object
}

export default View
